module.exports = __webpack_public_path__ + "img/Arachis_ipaensis.2d5fd849.jpg";